module.exports = __webpack_public_path__ + "img/75.10.pH.392de065.png";